import api from '../api'
import router from '../router';
import retry from "@/utils/retry";

const state = {
    leaderboard: localStorage.getItem('leaderboard') ? JSON.parse(localStorage.getItem('leaderboard')) : [],
    loading: false,
    ageLimit: [],
    campaign: null,
    videos: null,
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setAgeLimit(state, ageLimit) {
        state.ageLimit = ageLimit;
    },
    setLeaderboardData(state, leaderboard) {
        state.leaderboard = leaderboard;
    },
    setCampaign(state, payload) {
        state.campaign = payload;
    },
    setVideos(state, videos) {
        state.videos = videos;
    },
};

const getters = {
    getLeaderBoard(state) {
        let rank = 0;
        return state.leaderboard?.leaderboard?.map(leaderboard => {
            rank = leaderboard?.rank ?? rank + 1;
            return {
                rank: leaderboard?.rank ?? rank,
                name: leaderboard?.name ?? (localStorage.getItem("name") ? localStorage.getItem("name") : "-"),
                company: leaderboard?.company ?? "",
                mobile: leaderboard?.mobile ?? "",
                accuracy: leaderboard?.accuracy ?? 0,
                email: leaderboard?.email ?? ""
            }
        })
    }
};

const actions = {
    async uploadDetailsAndGetLeaderBoard({ commit, dispatch }, userDetails) {
        commit('setLoading', true);
        try {
            const data = await api.getLeaderBoard(userDetails);
            if (data) {
                localStorage.setItem('leaderboard', JSON.stringify(data));
                commit('setLeaderboardData', data)
            }
        }
        catch (e) {
            console.error("leaderboard error", e);
            await Promise.reject(e);
        }
        finally {
            commit('setLoading', false);
        }
    },
    async getCampaignDetails({ commit, dispatch }, name) {
        try {
            const data = await api.getCampaignDetails(name);
            commit('setCampaign', data);
            return data;
        }
        catch (e) {
            return null;
        }
    },
    async getCampaignVideos({ commit, dispatch }, name) {
        try {
            const data = await api.getCampaignVideos(name);
            commit('setVideos', data);
            return data;
        }
        catch (e) {
            return null;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
}
